import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';
import { IUserDetailsEntity } from '../../../entity';

export interface IVerifyQRCodeUseCase {
    execute(
        qrCode: string,
        make: string,
        model: string,
        platform: string,
        lang: string,
        apiToken: { [key: string]: string }
    ): Promise<IUserDetailsEntity>;
}

export class VerifyQRCodeUseCase implements IVerifyQRCodeUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        qrCode: string,
        make: string,
        model: string,
        platform: string,
        lang: string,
        apiToken: { [key: string]: string }
    ): Promise<IUserDetailsEntity> {
        const response = await this.authRepo.verifyQRCode(qrCode, make, model, platform, lang, apiToken);
        return response.data as IUserDetailsEntity;
    }
}
